<div class="digit-offer op-mt-20" *transloco="let t">
	<div *opFF="'online-origination-ua-promo-card'; else originalDigitOfferTemplate">
		<op-digit-offer-approved (OnClickTriggerAction)="onDigitOffer($event)"> </op-digit-offer-approved>
	</div>
	<ng-template #originalDigitOfferTemplate>
		<op-digit-offer-ua-approved [digitUrl]="digitUrl" (OnClickTriggerAction)="goToDigit()"></op-digit-offer-ua-approved>
	</ng-template>

	<p class="op-pt-40"></p>

	<op-learn-more iconSize="small" icon="op-pencil" [title]="t('DIGIT_OFFER_FOR_APPROVED.howToManageLoan')">
		<div>{{ t('DIGIT_OFFER_FOR_APPROVED.createOnlineAccount') }}</div>
		<ul>
			<li [innerHTML]="t('DIGIT_OFFER_FOR_APPROVED.onlineServingFeature0')"></li>
			<li [innerHTML]="t('DIGIT_OFFER_FOR_APPROVED.onlineServingFeature1')"></li>
			<li [innerHTML]="t('DIGIT_OFFER_FOR_APPROVED.onlineServingFeature2')"></li>
			<li [innerHTML]="t('DIGIT_OFFER_FOR_APPROVED.onlineServingFeature3')"></li>
			<li [innerHTML]="t('DIGIT_OFFER_FOR_APPROVED.onlineServingFeature4')"></li>
			<li [innerHTML]="t('DIGIT_OFFER_FOR_APPROVED.onlineServingFeature5')"></li>
		</ul>
		<button
			mat-flat-button
			color="secondary"
			id="gotoServicingBtn"
			*ngIf="isMobile && !showCreateButton"
			(click)="mobileService.emit()"
		>
			{{ t('LOAN_COMPLETED.gotoServicing') }}
		</button>

		<button
			mat-flat-button
			color="secondary"
			id="gotoServicesBtn"
			*ngIf="!isMobile && !showCreateButton"
			(click)="mobileService.emit()"
		>
			{{ t('LOAN_COMPLETED.gotoServices') }}
		</button>

		<button
			mat-flat-button
			color="secondary"
			id="gotoCreateAccountBtn"
			*ngIf="showCreateButton"
			(click)="createAccount.emit()"
		>
			{{ t('LOAN_COMPLETED.setUpAccount') }}
		</button>
	</op-learn-more>
</div>
